export default __webpack_public_path__ + "d67c30ead18b1d366bb1fde40edda838.png";